import React from "react";
import ActionRouter from './Action/Router';
export { getFields } from './Action/Router';

export default function ActionSupervisorRouter(props) {
    return (
        <ActionRouter {...props} mode='SUPERVISOR' />
    );
};
